import { observer } from 'mobx-react-lite';
import { AppState } from '../stores/appStateStore';
import { StyleState } from '../stores/styleStore';
import DropZone from './DropZone';
import LandingPage from './LandingPage';
import MessageListPage from './MessageListPage';
import Navbar from './Navbar';
import Navigation from './Navigation';
import MessageInfoMenu from './MessageInfoMenu';

const App = observer((props: AppProps) => {
	const { state, styles } = props;

	if (state.currentView === 'landing') {
		return (
			<div id='subroot' className={styles.get('app-wide').classNames}>
				<DropZone state={state} styles={styles} />
                <div className="flex-mother fill" >
                    <Navigation state={state} styles={styles} />
                    <div className="flex-mother-col fill" >
                        <Navbar state={state} styles={styles} />
                        <LandingPage state={state} styles={styles} />
                    </div>
                </div>
			</div>
		);
	} else if (state.currentView === 'messageList') {
        return (
			<div id='subroot' className={styles.get('app-wide').classNames}>
				<DropZone state={state} styles={styles} />
                <div className="flex-mother fill" >
                    <Navigation state={state} styles={styles} />
                    <div className="flex-mother-col fill overflow-hidden" >
                        <Navbar state={state} styles={styles} />
                        <MessageListPage state={state} styles={styles} />
                        <MessageInfoMenu state={state} styles={styles} />
                    </div>
                </div>
			</div>
        );
    } else {
		return <div/>;
	}
}); // App()

export interface AppProps {
	state: AppState;
	styles: StyleState;
}

export default App;
